// extracted by mini-css-extract-plugin
module.exports = {"banner":"fentanyl-banner-module--banner--2hXqT","bannerContainer":"fentanyl-banner-module--bannerContainer--2WYW5"};